/**
 * Select ページ用スクリプト
 * - Pick UP スライドショーの Swiper 初期化
 */
document.addEventListener('DOMContentLoaded', function () {
  const pickupSwiperEl = document.querySelector('.swiper-pickup');
  if (pickupSwiperEl && typeof Swiper !== 'undefined') {
    new Swiper('.swiper-pickup', {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 500,
      navigation: {
        nextEl: '.pickup-swiper-next',
        prevEl: '.pickup-swiper-prev',
      },
      loop: true,
      breakpoints: {
        551: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        751: {
          slidesPerView: 3,
          spaceBetween: 52,
        },
      },
    });
  }
});
